import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  dealStore,
  paymentStore,
  primaryCustomerStore,
  tradeStore,
  userStore,
  vehicleFromIndexerStore,
  vehicleListingStore,
} from '@/models/stores';
import { runInAction } from 'mobx';
import { useEffect } from 'react';

const useDeliveryQueuePageHydrateLocal = () => {
  const isDeliveryQueuePageActive = isPageActive(PAGE_ROUTES.DELIVERY_QUEUE);
  const shouldRun = isDeliveryQueuePageActive;

  useEffect(() => {
    if (!shouldRun) {
      return;
    }

    const hydrateDeliveryQueue = async () => {
      // Load active deals and related entities from IndexedDB
      // Delivery queue shows deals grouped by delivery preference
      await Promise.all([
        dealStore.hydrateActiveDeals(),
        primaryCustomerStore.hydrateLocal(),
        vehicleFromIndexerStore.hydrateLocal(),
        vehicleListingStore.hydrateLocal(),
        userStore.hydrateLocal(),
        paymentStore.hydrateLocal(),
        tradeStore.hydrateLocal(),
      ]);
    };

    runInAction(async () => {
      await hydrateDeliveryQueue();
    });
  }, [shouldRun]);
};

export default useDeliveryQueuePageHydrateLocal;
